import * as React from "react"
import { LocaleProvider, LocationProvider } from "./context"
import { Seo } from "./components/seo"

const wrapPageElement = ({ element, props }) => (
      <LocationProvider location={props.location}>
          <LocaleProvider pageContext={props.pageContext}>
              <Seo location={props.location} pageContext={props.pageContext} />
              {element}
          </LocaleProvider>
      </LocationProvider>

)

export { wrapPageElement }
